var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imageSrc),expression:"imageSrc"}],key:_vm.imageSrc,attrs:{"alt":_vm.alt,"title":_vm.alt,"src":"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="}})
}
var staticRenderFns = []

export { render, staticRenderFns }